import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useDisplay from "../../hooks/useDisplay";
import styled from "styled-components";
import PCContainer from "../../components/atoms/layout/pcContainer";
import LSRgDisplay02 from "./../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import { route } from "../../router/route";
import ProfileIcon from "../../components/atoms/ProfileIcon";
import LSBdDisplay02 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import PrimaryBtn from "../../components/atoms/button/primaryBtn";
import InputLabel from "../../components/atoms/input/inputLabel";
import LSBdH1HeadLine from "./../../components/molecules/text/linSeedKr/Bd/lsBdH1HeadLine";
import InputField from "../../components/atoms/input/inputField";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import { tabList } from "./../../constant/myPageTab";
import MOContainer from "../../components/atoms/layout/moContainer";
import SelectBox from "../../components/organisms/SelectBox";
import MemberApi from "../../api/member.api";
import FileApi from "../../api/file.api";
import { fileUrl } from "../../api/api";
import { toast } from "react-toastify";
import AuthApi from "../../api/auth.api";
import { formatPhoneNumber, removeNonNumeric } from "../../util/formatNumber";
import regex from "../../constants/regex";
import StyledCategoryItem from "../../components/molecules/button/styledCategoryItem";
import { errorHandler } from "../../util/errorHandler";

const MyPageSetting = () => {
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;
  const isNormalMember = sessionStorage.getItem("joinType") === "NORMAL";

  // ---------- 모바일 버전 탭 관련 ---------- //
  const [subMenuBoxOpen, setSubMenuBoxOpen] = useState(false);
  const [selectedSubMenu, setSelectedSubMenu] = useState(tabList[0].title);

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("로그인이 필요한 서비스입니다.");
      navigate(
        `${route.login}?returnUrl=${encodeURIComponent(route.my_page_setting)}`,
        { replace: true },
      );
      return;
    }

    getMyInfo();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 내 정보 가져오기 ---------- //
  const [myInfo, setMyInfo] = useState({});

  const getMyInfo = async () => {
    try {
      const response = (await MemberApi.getMyInfo()).data.data.content;

      setMyInfo(response);
      sessionStorage.setItem("email", response.email ?? "");
      sessionStorage.setItem("name", response.name ?? "");
      sessionStorage.setItem("nickname", response.nickname ?? "");
      sessionStorage.setItem("phoneNumber", response.phoneNumber ?? "");
      sessionStorage.setItem("profile", response.profileServerFileName ?? "");
      sessionStorage.setItem(
        "membership",
        String(Boolean(response.membership)),
      );

      // 회원 정보 수정 후 초기 상태로 전환 시 입력값 전부 초기화 필요하여 전개 구문 사용하지 않음
      setSettingInputValue({
        currentPw: "",
        newPw: "",
        newPwCheck: "",
        nickname: response.nickname,
        phoneNumber: formatPhoneNumber(response.phoneNumber),
        certNum: "",
        email: response.email,
      });

      if (response.profileOriginFileName || response.profileServerFileName) {
        setProfileImage({
          file: "",
          fileUrl: `${fileUrl}/${response.profileServerFileName}`,
          fileName: response.profileOriginFileName,
        });
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 인풋 입력 영역 관련 ---------- //
  // 인풋 입력값 상태
  const [settingInputValue, setSettingInputValue] = useState({
    currentPw: "",
    newPw: "",
    newPwCheck: "",
    nickname: "",
    phoneNumber: "",
    certNum: "",
    email: "",
  });

  // 유효성 검사 관련
  const [currentPwRegexTest, setCurrentPwRegexTest] = useState(true); // 현재 비밀번호 정규식 테스트
  const [newPwRegexTest, setNewPwRegexTest] = useState(true); // 새 비밀번호 정규식 테스트
  const [newPwCheckRegexTest, setNewPwCheckRegexTest] = useState(true); // 새 비밀번호 확인 정규식 테스트
  const [nicknameRegexTest, setNicknameRegexTest] = useState(true); // 닉네임 정규식 테스트
  const [nicknameDuplicateCheck, setNicknameDuplicateCheck] = useState(false); // 닉네임 중복 확인
  const [phoneNumberRegexTest, setPhoneNumberRegexTest] = useState(true); // 전화번호 정규식 테스트
  const [certNumSent, setCertNumSent] = useState(false); // 인증번호 발송 여부 상태
  const [certNumRegexTest, setCertNumRegexTest] = useState(true);
  const [verifyCertNum, setVerifyCertNum] = useState(false); // 인증번호 확인 여부 상태
  const [emailRegexTest, setEmailRegexTest] = useState(true); // 이메일 정규식 테스트

  const [isPwChange, setIsPwChange] = useState(true);

  // 정규식 검사 함수
  const validateInput = (regex, value) => {
    return regex.test(value);
  };

  // 인풋 영역 핸들러
  const handleInputValueChange = (e) => {
    const { name, value } = e.target;

    let processedValue = value.replace(/\s+/g, ""); // 공백 제거

    if (name === "certNum") {
      processedValue = removeNonNumeric(value); // 숫자만 입력되도록
    }

    setSettingInputValue((prevState) => ({
      ...prevState,
      [name]: processedValue,
    }));

    if (name === "nickname") {
      setNicknameDuplicateCheck(false);
    }

    if (name === "phoneNumber") {
      setIsShowPhoneNumberChange(false);
      setVerifyCertNum(false);
      setCertNumSent(false);
      setSettingInputValue((prevState) => ({ ...prevState, certNum: "" }));
    }

    const validateField = (name, value) => {
      switch (name) {
        case "currentPw":
          if (value !== "") {
            setCurrentPwRegexTest(validateInput(regex.pw, value));
          } else {
            setCurrentPwRegexTest(true);
          }
          break;
        case "newPw":
          if (value !== "") {
            setNewPwRegexTest(validateInput(regex.pw, value));
          } else {
            setNewPwRegexTest(true);
          }
          break;
        case "newPwCheck":
          if (value !== "") {
            setNewPwCheckRegexTest(settingInputValue.newPw === value);
          } else {
            setNewPwCheckRegexTest(true);
          }
          break;
        case "nickname":
          if (value !== "") {
            setNicknameRegexTest(validateInput(regex.nickname, value));
          } else {
            setNicknameRegexTest(true);
          }
          break;
        case "phoneNumber":
          if (value !== "") {
            setPhoneNumberRegexTest(
              validateInput(regex.phoneNumber, removeNonNumeric(value)),
            );
            setIsShowPhoneNumberChange(false);
          } else {
            setPhoneNumberRegexTest(true);
          }
          break;
        case "certNum":
          if (value !== "") {
            setCertNumRegexTest(validateInput(regex.certNum, value));
          } else {
            setCertNumRegexTest(true);
          }
          break;
        case "email":
          if (value !== "") {
            setEmailRegexTest(validateInput(regex.email, value));
          } else {
            setEmailRegexTest(true);
          }
          break;

        default:
          toast("Invalid field name");
          console.error("Invalid field name");
      }
    };

    validateField(name, processedValue);
  };

  // 비밀번호 변경 관련
  const [isShowPwChange, setIsShowPwChange] = useState(false);

  const handlePwChangeMode = async () => {
    try {
      const obj = {
        email: myInfo.account,
        password: settingInputValue.currentPw,
      };
      const response = await AuthApi.login(obj);

      if (response) {
        setIsShowPwChange(true);
      }
    } catch (error) {
      console.error(error);
      toast("현재 비밀번호가 일치하지 않습니다.");
      setIsShowPwChange(false);
    }
  };

  // 닉네임 중복 확인 함수
  const checkDuplicateNickname = async () => {
    try {
      const data = {
        nickname: settingInputValue.nickname,
      };
      await AuthApi.nicknameCheck(data);
      toast("사용 가능한 닉네임입니다.");
      setNicknameDuplicateCheck(true);
    } catch (error) {
      console.error(error);
      setNicknameDuplicateCheck(false);
      toast("이미 등록된 닉네임입니다.");
    }
  };

  // ---------- 전화번호 변경 관련 ---------- //
  const [isShowPhoneNumberChange, setIsShowPhoneNumberChange] = useState(false);

  // 전화번호 변경 모드로 전환 핸들러 (전화번호 중복 확인)
  const handlePhoneNumberChangeMode = async () => {
    try {
      const data = {
        phoneNumber: removeNonNumeric(settingInputValue.phoneNumber),
      };

      const response = await AuthApi.phoneCheck(data);

      if (response) {
        setIsShowPhoneNumberChange(true);
        handleCertNumSend();
      }
    } catch (error) {
      console.error(error);
      toast("이미 등록된 전화번호입니다.");
    }
  };

  // 인증번호 발송 핸들러
  const handleCertNumSend = async () => {
    try {
      setVerifyCertNum(false);
      setSettingInputValue((prevState) => ({
        ...prevState,
        certNum: "",
      }));

      const data = {
        phoneNumber: removeNonNumeric(settingInputValue.phoneNumber),
      };

      const response = (await AuthApi.sendSMS(data)).data.data.authNumber;

      sessionStorage.setItem("fl_certNum", response);
      setCertNumSent(true);

      toast(
        response === "000000"
          ? "개발용 인증번호는 000000입니다."
          : "인증번호가 발송되었습니다.",
      );
    } catch (error) {
      console.error(error);
      toast("인증번호 발송에 실패했습니다.");
      setCertNumSent(false);
    }
  };

  useEffect(() => {
    if (!certNumSent) {
      sessionStorage.removeItem("fl_certNum"); // 인증번호 세션 삭제
    }
  }, [certNumSent]);

  // 인증번호 확인 함수
  const handleCertNumVerify = () => {
    const certNum = sessionStorage.getItem("fl_certNum");
    const inputCertNum = settingInputValue.certNum;

    if (certNum && certNum === inputCertNum) {
      setVerifyCertNum(true);
      toast("인증번호 확인 완료");
      sessionStorage.removeItem("fl_certNum");
    } else {
      setVerifyCertNum(false);
      setCertNumRegexTest(false);
      toast("인증번호를 다시 확인해주세요.");
    }
  };

  // ---------- 프로필 사진 관련 ---------- //
  const [profileImage, setProfileImage] = useState({
    file: "",
    fileUrl: "",
    fileName: "",
  });

  // 프로필 사진 파일 업로드
  const inputProfileImageFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!["image/jpeg", "image/png"].includes(file.type)) {
      toast("JPG 또는 PNG 이미지만 업로드할 수 있습니다.");
      e.target.value = "";
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      toast("프로필 이미지는 5MB 이하만 가능합니다.");
      e.target.value = "";
      return;
    }

    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = (value) => {
      setProfileImage({
        file: file,
        fileUrl: value.target.result,
        fileName: file.name,
      });
    };

    e.target.value = "";
  };

  // ---------- 정보 수정 제출 관련 ---------- //
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleEditInfo = async () => {
    if (isSubmitting) return;

    try {
      if (isNormalMember && settingInputValue.currentPw === "") {
        toast("현재 비밀번호를 입력해 주세요.");
        return;
      }

      if (!nicknameRegexTest) {
        toast("닉네임을 올바르게 입력해 주세요.");
        return;
      }

      if (isShowPwChange && !newPwRegexTest) {
        toast("새 비밀번호를 올바르게 입력해 주세요.");
        return;
      }

      setIsSubmitting(true);

      let loginResponse = true;
      if (isNormalMember) {
        loginResponse = await AuthApi.login({
          email: myInfo.account,
          password: settingInputValue.currentPw,
        });
      }

      // 현재 비밀번호가 일치하지 않으면 아래 코드 실행 안함
      if (loginResponse) {
        if (
          isShowPwChange &&
          settingInputValue.currentPw === settingInputValue.newPw
        ) {
          toast("현재 비밀번호와 새 비밀번호가 동일합니다.");
          return;
        } else if (isShowPwChange && settingInputValue.newPw === "") {
          toast("새 비밀번호를 입력해 주세요.");
          return;
        } else if (isShowPwChange && settingInputValue.newPwCheck === "") {
          toast("새 비밀번호 확인을 입력해 주세요.");
          return;
        } else if (
          isShowPwChange &&
          settingInputValue.newPw !== settingInputValue.newPwCheck
        ) {
          toast("새 비밀번호와 새 비밀번호 확인이 일치하지 않습니다.");
          setNewPwCheckRegexTest(false);
          return;
        } else if (settingInputValue.nickname === "") {
          toast("닉네임을 입력해 주세요.");
          return;
        } else if (
          settingInputValue.nickname !== myInfo.nickname &&
          !nicknameDuplicateCheck
        ) {
          toast("닉네임 중복 확인을 해주세요.");
          return;
        } else if (settingInputValue.phoneNumber === "") {
          toast("전화번호를 입력해 주세요.");
          return;
        } else if (!phoneNumberRegexTest) {
          toast("전화번호를 올바르게 입력해 주세요.");
          return;
        } else if (
          removeNonNumeric(settingInputValue.phoneNumber) !==
            myInfo.phoneNumber &&
          !verifyCertNum
        ) {
          toast("인증번호 확인을 해주세요.");
          return;
        } else if (settingInputValue.email === "") {
          toast("이메일을 입력해 주세요.");
          return;
        } else if (!emailRegexTest) {
          toast("이메일을 올바르게 입력해 주세요.");
          return;
        }

        const data = {
          passwordChangeFlag: false,
          nicknameChangeFlag: false,
          phoneNumberChangeFlag: false,
          password: settingInputValue.currentPw,
          nickname: settingInputValue.nickname,
          phoneNumber: removeNonNumeric(settingInputValue.phoneNumber),
          name: myInfo.name,
          birth: myInfo.birth,
          email: settingInputValue.email,
          marketingAgreement: myInfo.marketingAgreement,
          adAgreement: myInfo.adAgreement,
          smsAgreement: myInfo.smsAgreement,
          profileOriginFileName: myInfo.profileOriginFileName,
          profileServerFileName: myInfo.profileServerFileName,
        };

        // 프로필 사진 변경 시
        let profileImageResponse;

        if (profileImage.file) {
          profileImageResponse = (
            await FileApi.fileUpload(profileImage.file, "client")
          ).data.data;
          data.profileOriginFileName = profileImage.fileName;
          data.profileServerFileName = profileImageResponse.serverFileName;

          sessionStorage.setItem(
            "profile",
            profileImageResponse.serverFileName,
          );
        }

        if (isShowPwChange) {
          data.passwordChangeFlag = true;
          data.password = settingInputValue.newPw;
        }

        if (settingInputValue.nickname !== myInfo.nickname) {
          data.nicknameChangeFlag = true;
        }

        if (
          removeNonNumeric(settingInputValue.phoneNumber) !== myInfo.phoneNumber
        ) {
          data.phoneNumberChangeFlag = true;
        }

        await MemberApi.updateMyInfo(data);
        toast("정보 수정이 완료되었습니다.");
        handleReset();
      }
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  // 초기 상태로 전환
  const handleReset = () => {
    getMyInfo();
    setIsShowPwChange(false);
    setIsShowPhoneNumberChange(false);
    setVerifyCertNum(false);
    setCertNumSent(false);
    setNicknameDuplicateCheck(false);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // ---------- 회원탈퇴 관련 ---------- //

  return (
    <HomeSection $isSmall={isSmall}>
      {isDesktop && (
        <PCContainer
          style={{
            flexDirection: "column",
            width: "100%",
            padding: isSmall ? "0px 20px" : "0px",
          }}
        >
          <LSRgDisplay02
            style={{
              color: "#000",
              marginBottom: 32,
            }}
          >
            👨‍💻 마이페이지
          </LSRgDisplay02>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "fit-content",
              gap: 30,
            }}
          >
            {/* 탭 영역 */}
            <TabContainer>
              {tabList.map((tab, index) => (
                <StyledCategoryItem
                  key={index}
                  onClick={() => navigate(tab.path)}
                  isActive={index === 0 ? true : false}
                  title={tab.title}
                />
              ))}
            </TabContainer>
            {/* 본문 영역 */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 30,
              }}
            >
              <ContentContainer>
                {/* 본문 영역 - 프로필 */}
                <ProfileWrapper>
                  <ProfileIcon imgUrl={profileImage.fileUrl} />
                  <ProfileLabel htmlFor="profile">
                    <ProfileEditIcon
                      src="/assets/icons/edit.png"
                      alt="프로필 사진 수정하기"
                    />
                  </ProfileLabel>
                  <ProfileEditInput
                    type="file"
                    id="profile"
                    name="profile"
                    onChange={(e) => {
                      inputProfileImageFile(e);
                    }}
                    accept={"image/png, image/jpeg, image/jpg"}
                  />
                </ProfileWrapper>

                <ContentWrapper>
                  {/* 본문 영역 - 정보 입력 */}
                  <LSBdDisplay02
                    style={{
                      color: "#000",
                      margin: "40px 0px 30px 0px",
                    }}
                  >
                    계정 정보 수정
                  </LSBdDisplay02>
                  <InputContainer>
                    {isNormalMember ? (
                      <>
                        <InputLabel>
                          <LSBdH1HeadLine
                            style={{ color: "#101113", marginLeft: 5 }}
                          >
                            아이디
                          </LSBdH1HeadLine>
                          <InputField
                            id="id"
                            name="id"
                            placeholder="아이디를 입력해 주세요."
                            type="text"
                            autoComplete="off"
                            value={myInfo.account || ""}
                            disabled={true}
                          />
                        </InputLabel>

                        {!isShowPwChange && (
                          <InputLabel>
                            <LSBdH1HeadLine
                              style={{ color: "#101113", marginLeft: 5 }}
                            >
                              비밀번호
                            </LSBdH1HeadLine>
                            <InputField
                              disabled={isPwChange}
                              id="currentPw"
                              name="currentPw"
                              placeholder="비밀번호를 입력해 주세요."
                              type="password"
                              autoComplete="off"
                              value={settingInputValue.currentPw}
                              onChange={(e) => {
                                handleInputValueChange(e);
                              }}
                              isWarring={!currentPwRegexTest}
                              warringMsg={
                                "문자/숫자/특수기호 중 2가지 이상 조합 (글자수 8자~16자)"
                              }
                              isShowBtn={true}
                              btnText={"변경하기"}
                              btnHandler={() => {
                                if (isPwChange) {
                                  setIsPwChange(false);
                                  return;
                                }

                                if (settingInputValue.currentPw === "") {
                                  toast("현재 비밀번호를 입력해 주세요.");
                                  return;
                                }

                                handlePwChangeMode();
                              }}
                            />
                          </InputLabel>
                        )}

                        {isShowPwChange && (
                          <>
                            <InputLabel>
                              <LSBdH1HeadLine
                                style={{ color: "#101113", marginLeft: 5 }}
                              >
                                새로운 비밀번호
                              </LSBdH1HeadLine>
                              <InputField
                                id="newPw"
                                name="newPw"
                                placeholder="새로운 비밀번호를 입력해 주세요."
                                type="password"
                                autoComplete="off"
                                value={settingInputValue.newPw}
                                onChange={(e) => {
                                  handleInputValueChange(e);
                                }}
                                isGuide={newPwRegexTest}
                                guideMsg={
                                  "문자/숫자/특수기호 중 2가지 이상 조합 (글자수 8자~16자)"
                                }
                                isWarring={!newPwRegexTest}
                                warringMsg={
                                  "문자/숫자/특수기호 중 2가지 이상 조합 (글자수 8자~16자)"
                                }
                              />
                            </InputLabel>

                            <InputLabel>
                              <LSBdH1HeadLine
                                style={{ color: "#101113", marginLeft: 5 }}
                              >
                                새로운 비밀번호 확인
                              </LSBdH1HeadLine>
                              <InputField
                                id="newPwCheck"
                                name="newPwCheck"
                                placeholder="새로운 비밀번호를 한 번 더 입력해 주세요."
                                type="password"
                                autoComplete="off"
                                value={settingInputValue.newPwCheck}
                                onChange={(e) => {
                                  handleInputValueChange(e);
                                }}
                                isWarring={!newPwCheckRegexTest}
                                warringMsg={"비밀번호가 일치하지 않습니다."}
                              />
                            </InputLabel>
                          </>
                        )}
                      </>
                    ) : (
                      <InputLabel>
                        <LSBdH1HeadLine
                          style={{ color: "#101113", marginLeft: 5 }}
                        >
                          아이디
                        </LSBdH1HeadLine>
                        <InputField
                          id="id"
                          name="id"
                          placeholder="아이디를 입력해 주세요."
                          type="text"
                          autoComplete="off"
                          value={
                            sessionStorage.getItem("joinType") === "KAKAO"
                              ? "카카오 회원"
                              : "네이버 회원"
                          }
                          disabled={true}
                        />
                      </InputLabel>
                    )}

                    <InputLabel>
                      <LSBdH1HeadLine
                        style={{ color: "#101113", marginLeft: 5 }}
                      >
                        닉네임
                      </LSBdH1HeadLine>
                      <InputField
                        id="nickname"
                        name="nickname"
                        placeholder="닉네임을 입력해 주세요."
                        type="text"
                        autoComplete="off"
                        value={settingInputValue.nickname}
                        onChange={(e) => {
                          handleInputValueChange(e);
                        }}
                        isGuide={nicknameRegexTest}
                        guideMsg={
                          "띄어쓰기 없이 최대 10자 제한 (한글, 영문, 숫자만 사용 가능)"
                        }
                        isWarring={!nicknameRegexTest}
                        warringMsg={"닉네임을 올바르게 입력해 주세요."}
                        isShowBtn={true}
                        btnText={"중복확인"}
                        btnHandler={() => {
                          if (settingInputValue.nickname === "") {
                            toast("닉네임을 입력해 주세요.");
                            return;
                          } else if (
                            settingInputValue.nickname === myInfo.nickname
                          ) {
                            toast("현재 닉네임과 동일합니다.");
                            return;
                          } else if (!nicknameRegexTest) {
                            toast("닉네임을 올바르게 입력해 주세요.");
                            return;
                          }

                          checkDuplicateNickname();
                        }}
                      />
                    </InputLabel>

                    <InputLabel>
                      <LSBdH1HeadLine
                        style={{ color: "#101113", marginLeft: 5 }}
                      >
                        이름
                      </LSBdH1HeadLine>
                      <InputField
                        id="name"
                        name="name"
                        placeholder="이름를 입력해 주세요."
                        type="text"
                        autoComplete="off"
                        value={myInfo.name || ""}
                        disabled={true}
                      />
                    </InputLabel>

                    <InputLabel>
                      <LSBdH1HeadLine
                        style={{ color: "#101113", marginLeft: 5 }}
                      >
                        전화번호
                      </LSBdH1HeadLine>
                      <InputField
                        id="phoneNumber"
                        name="phoneNumber"
                        placeholder="000-0000-0000"
                        type="text"
                        autoComplete="off"
                        value={settingInputValue.phoneNumber}
                        onChange={(e) => {
                          handleInputValueChange(e);
                        }}
                        isWarring={!phoneNumberRegexTest}
                        warringMsg={"전화번호를 올바르게 입력해 주세요."}
                        isShowBtn={true}
                        btnText={"인증발송"}
                        btnHandler={() => {
                          if (settingInputValue.phoneNumber === "") {
                            toast("전화번호를 입력해 주세요.");
                            return;
                          } else if (
                            removeNonNumeric(settingInputValue.phoneNumber) ===
                            myInfo.phoneNumber
                          ) {
                            toast("현재 전화번호와 동일합니다.");
                            return;
                          } else if (!phoneNumberRegexTest) {
                            toast("전화번호를 올바르게 입력해 주세요.");
                            return;
                          }

                          handlePhoneNumberChangeMode();
                        }}
                      />
                      {isShowPhoneNumberChange && (
                        <InputField
                          id="certNum"
                          name="certNum"
                          placeholder="인증코드를 입력해 주세요."
                          type="text"
                          autoComplete="off"
                          value={settingInputValue.certNum}
                          onChange={(e) => {
                            handleInputValueChange(e);
                          }}
                          isWarring={!certNumRegexTest}
                          warringMsg={"인증번호를 올바르게 입력해 주세요."}
                          isShowBtn={true}
                          disabled={verifyCertNum}
                          btnText={verifyCertNum ? "인증완료" : "인증확인"}
                          btnHandler={() => {
                            if (verifyCertNum) return;

                            if (settingInputValue.certNum === "") {
                              toast("인증번호를 입력해 주세요.");
                              return;
                            }

                            handleCertNumVerify();
                          }}
                        />
                      )}
                    </InputLabel>

                    <InputLabel>
                      <LSBdH1HeadLine
                        style={{ color: "#101113", marginLeft: 5 }}
                      >
                        생년월일
                      </LSBdH1HeadLine>
                      <InputField
                        id="birth"
                        name="birth"
                        placeholder="YYYYMMDD"
                        type="text"
                        autoComplete="off"
                        value={myInfo.birth || ""}
                        disabled={true}
                      />
                    </InputLabel>

                    <InputLabel>
                      <LSBdH1HeadLine
                        style={{ color: "#101113", marginLeft: 5 }}
                      >
                        이메일
                      </LSBdH1HeadLine>
                      <InputField
                        id="email"
                        name="email"
                        placeholder="example1234@naver.com"
                        type="text"
                        autoComplete="off"
                        value={settingInputValue.email}
                        onChange={(e) => {
                          handleInputValueChange(e);
                        }}
                        isWarring={!emailRegexTest}
                        warringMsg={"이메일을 올바르게 입력해 주세요."}
                      />
                    </InputLabel>
                  </InputContainer>
                  <EditBtnWrapper>
                    <PrimaryBtn
                      disabled={isSubmitting}
                      btnText={isSubmitting ? "수정 중..." : "정보 수정하기"}
                      onClick={handleEditInfo}
                    />
                  </EditBtnWrapper>
                </ContentWrapper>
              </ContentContainer>

              {/* 회원탈퇴 버튼 */}
              <WithdrawalBtn
                onClick={() => {
                  navigate(route.my_page_setting_withdrawal);
                }}
              >
                <LSRgH1HeadLine style={{ color: "#898E99" }}>
                  회원탈퇴
                </LSRgH1HeadLine>
              </WithdrawalBtn>
            </div>
          </div>
        </PCContainer>
      )}

      {/* ******************************** */}
      {/* ********** 모바일 버전 ********** */}
      {/* ******************************** */}
      {isSmall && (
        <MOContainer>
          <ContentContainer $isSmall={isSmall}>
            <ContentHeaderWrapper>
              <LSRgH1HeadLine>👨‍💻 마이페이지</LSRgH1HeadLine>
              <SelectBox
                style={{
                  width: "100%",
                }}
                subMenuStyle={{
                  width: "100%",
                }}
                isSmall={true}
                isOpen={subMenuBoxOpen}
                isLink={true}
                selectedValue={selectedSubMenu}
                wrapperHandler={() => {
                  setSubMenuBoxOpen(!subMenuBoxOpen);
                }}
                itemList={tabList}
                selectedValueSetterFunc={setSelectedSubMenu}
              />
            </ContentHeaderWrapper>

            <ContentWrapper $isSmall={isSmall}>
              <ProfileWrapper
                $isSmall={isSmall}
                style={{
                  alignSelf: "center",
                  marginBottom: 32,
                }}
              >
                <ProfileIcon imgUrl={profileImage.fileUrl} isSmall={isSmall} />
                <ProfileLabel htmlFor="profile" $isSmall={isSmall}>
                  <ProfileEditIcon
                    src="/assets/icons/edit.png"
                    alt="프로필 사진 수정하기"
                  />
                </ProfileLabel>
                <ProfileEditInput
                  type="file"
                  id="profile"
                  name="profile"
                  onChange={(e) => {
                    inputProfileImageFile(e);
                  }}
                  accept={"image/png, image/jpeg, image/jpg"}
                />
              </ProfileWrapper>
            </ContentWrapper>

            <InputContainer>
              <InputLabel>
                <LSBdH1HeadLine style={{ color: "#101113", marginLeft: 5 }}>
                  아이디
                </LSBdH1HeadLine>
                <InputField
                  isSmall={isSmall}
                  id="id"
                  name="id"
                  placeholder="아이디를 입력해 주세요."
                  type="text"
                  autoComplete="off"
                  value={
                    isNormalMember
                      ? myInfo.account || ""
                      : sessionStorage.getItem("joinType") === "KAKAO"
                        ? "카카오 회원"
                        : "네이버 회원"
                  }
                  disabled={true}
                />
              </InputLabel>

              {isNormalMember && !isShowPwChange && (
                <InputLabel>
                  <LSBdH1HeadLine style={{ color: "#101113", marginLeft: 5 }}>
                    비밀번호
                  </LSBdH1HeadLine>
                  <InputField
                    disabled={isPwChange}
                    isSmall={isSmall}
                    id="currentPw"
                    name="currentPw"
                    placeholder="비밀번호를 입력해 주세요."
                    type="password"
                    autoComplete="off"
                    value={settingInputValue.currentPw}
                    onChange={(e) => {
                      handleInputValueChange(e);
                    }}
                    isWarring={!currentPwRegexTest}
                    warringMsg={
                      "문자/숫자/특수기호 중 2가지 이상 조합 (글자수 8자~16자)"
                    }
                    isShowBtn={true}
                    btnText={"변경하기"}
                    btnHandler={() => {
                      if (isPwChange) {
                        setIsPwChange(false);
                        return;
                      }

                      if (settingInputValue.currentPw === "") {
                        toast("현재 비밀번호를 입력해 주세요.");
                        return;
                      }

                      handlePwChangeMode();
                    }}
                  />
                </InputLabel>
              )}

              {isNormalMember && isShowPwChange && (
                <>
                  <InputLabel>
                    <LSBdH1HeadLine style={{ color: "#101113", marginLeft: 5 }}>
                      새로운 비밀번호
                    </LSBdH1HeadLine>
                    <InputField
                      isSmall={isSmall}
                      id="newPw"
                      name="newPw"
                      placeholder="새로운 비밀번호를 입력해 주세요."
                      type="password"
                      autoComplete="off"
                      value={settingInputValue.newPw}
                      onChange={(e) => {
                        handleInputValueChange(e);
                      }}
                      isGuide={newPwRegexTest}
                      guideMsg={
                        "문자/숫자/특수기호 중 2가지 이상 조합 (글자수 8자~16자)"
                      }
                      isWarring={!newPwRegexTest}
                      warringMsg={
                        "문자/숫자/특수기호 중 2가지 이상 조합 (글자수 8자~16자)"
                      }
                    />
                  </InputLabel>

                  <InputLabel>
                    <LSBdH1HeadLine style={{ color: "#101113", marginLeft: 5 }}>
                      새로운 비밀번호 확인
                    </LSBdH1HeadLine>
                    <InputField
                      isSmall={isSmall}
                      id="newPwCheck"
                      name="newPwCheck"
                      placeholder="새로운 비밀번호를 한 번 더 입력해 주세요."
                      type="password"
                      autoComplete="off"
                      value={settingInputValue.newPwCheck}
                      onChange={(e) => {
                        handleInputValueChange(e);
                      }}
                      isWarring={!newPwCheckRegexTest}
                      warringMsg={"비밀번호가 일치하지 않습니다."}
                    />
                  </InputLabel>
                </>
              )}

              <InputLabel>
                <LSBdH1HeadLine style={{ color: "#101113", marginLeft: 5 }}>
                  닉네임
                </LSBdH1HeadLine>
                <InputField
                  isSmall={isSmall}
                  id="nickname"
                  name="nickname"
                  placeholder="닉네임을 입력해 주세요."
                  type="text"
                  autoComplete="off"
                  value={settingInputValue.nickname}
                  onChange={(e) => {
                    handleInputValueChange(e);
                  }}
                  isGuide={nicknameRegexTest}
                  guideMsg={
                    "띄어쓰기 없이 최대 10자 제한 (한글, 영문, 숫자만 사용 가능)"
                  }
                  isWarring={!nicknameRegexTest}
                  warringMsg={"닉네임을 올바르게 입력해 주세요."}
                  isShowBtn={true}
                  btnText={"중복확인"}
                  btnHandler={() => {
                    if (settingInputValue.nickname === "") {
                      toast("닉네임을 입력해 주세요.");
                      return;
                    } else if (settingInputValue.nickname === myInfo.nickname) {
                      toast("현재 닉네임과 동일합니다.");
                      return;
                    } else if (!nicknameRegexTest) {
                      toast("닉네임을 올바르게 입력해 주세요.");
                      return;
                    }

                    checkDuplicateNickname();
                  }}
                />
              </InputLabel>

              <InputLabel>
                <LSBdH1HeadLine style={{ color: "#101113", marginLeft: 5 }}>
                  이름
                </LSBdH1HeadLine>
                <InputField
                  isSmall={isSmall}
                  id="name"
                  name="name"
                  placeholder="이름를 입력해 주세요."
                  type="text"
                  autoComplete="off"
                  value={myInfo.name || ""}
                  disabled={true}
                />
              </InputLabel>

              <InputLabel>
                <LSBdH1HeadLine style={{ color: "#101113", marginLeft: 5 }}>
                  전화번호
                </LSBdH1HeadLine>
                <InputField
                  isSmall={isSmall}
                  id="phoneNumber"
                  name="phoneNumber"
                  placeholder="000-0000-0000"
                  type="text"
                  autoComplete="off"
                  value={settingInputValue.phoneNumber}
                  onChange={(e) => {
                    handleInputValueChange(e);
                  }}
                  isWarring={!phoneNumberRegexTest}
                  warringMsg={"전화번호를 올바르게 입력해 주세요."}
                  isShowBtn={true}
                  btnText={"인증발송"}
                  btnHandler={() => {
                    if (settingInputValue.phoneNumber === "") {
                      toast("전화번호를 입력해 주세요.");
                      return;
                    } else if (
                      removeNonNumeric(settingInputValue.phoneNumber) ===
                      myInfo.phoneNumber
                    ) {
                      toast("현재 전화번호와 동일합니다.");
                      return;
                    } else if (!phoneNumberRegexTest) {
                      toast("전화번호를 올바르게 입력해 주세요.");
                      return;
                    }

                    handlePhoneNumberChangeMode();
                  }}
                />
                {isShowPhoneNumberChange && (
                  <InputField
                    isSmall={isSmall}
                    id="certNum"
                    name="certNum"
                    placeholder="인증코드를 입력해 주세요."
                    type="text"
                    autoComplete="off"
                    value={settingInputValue.certNum}
                    onChange={(e) => {
                      handleInputValueChange(e);
                    }}
                    isWarring={!certNumRegexTest}
                    warringMsg={"인증번호를 올바르게 입력해 주세요."}
                    isShowBtn={true}
                    disabled={verifyCertNum}
                    btnText={verifyCertNum ? "인증완료" : "인증확인"}
                    btnHandler={() => {
                      if (verifyCertNum) return;

                      if (settingInputValue.certNum === "") {
                        toast("인증번호를 입력해 주세요.");
                        return;
                      }

                      handleCertNumVerify();
                    }}
                  />
                )}
              </InputLabel>

              <InputLabel>
                <LSBdH1HeadLine style={{ color: "#101113", marginLeft: 5 }}>
                  생년월일
                </LSBdH1HeadLine>
                <InputField
                  isSmall={isSmall}
                  id="birth"
                  name="birth"
                  placeholder="YYYYMMDD"
                  type="text"
                  autoComplete="off"
                  value={myInfo.birth || ""}
                  disabled={true}
                />
              </InputLabel>

              <InputLabel>
                <LSBdH1HeadLine style={{ color: "#101113", marginLeft: 5 }}>
                  이메일
                </LSBdH1HeadLine>
                <InputField
                  isSmall={isSmall}
                  id="email"
                  name="email"
                  placeholder="example1234@naver.com"
                  type="text"
                  autoComplete="off"
                  value={settingInputValue.email}
                  onChange={(e) => {
                    handleInputValueChange(e);
                  }}
                  isWarring={!emailRegexTest}
                  warringMsg={"이메일을 올바르게 입력해 주세요."}
                />
              </InputLabel>
            </InputContainer>

            <EditBtnWrapper $isSmall={isSmall}>
              <PrimaryBtn
                disabled={isSubmitting}
                btnText={isSubmitting ? "수정 중..." : "정보 수정하기"}
                onClick={handleEditInfo}
              />
            </EditBtnWrapper>

            {/* 회원탈퇴 버튼 */}
            <WithdrawalBtn
              onClick={() => {
                navigate(route.my_page_setting_withdrawal);
              }}
            >
              <LSRgH1HeadLine style={{ color: "#898E99" }}>
                회원탈퇴
              </LSRgH1HeadLine>
            </WithdrawalBtn>
          </ContentContainer>
        </MOContainer>
      )}
    </HomeSection>
  );
};

export default MyPageSetting;

const HomeSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: ${(props) =>
    props.$isSmall ? "40px 0px 80px 0px" : "80px 0px 150px 0px"};
`;

const TabContainer = styled.div.attrs((props) => {})`
  width: 175px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ContentContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  display: flex;
  flex-direction: ${(props) => (props.$isSmall ? "column" : "row")};
  gap: ${(props) => (props.$isSmall ? "0px" : "75px")};
  padding: ${(props) => (props.$isSmall ? "0px" : "40px")};
  box-shadow: ${(props) =>
    props.$isSmall ? "" : "0px 0px 6px rgba(0, 0, 0, 0.1)"};
  border-radius: ${(props) => (props.$isSmall ? "" : "30px")};
`;

const ContentHeaderWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 40px;
`;

const ContentWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  width: ${(props) => (props.$isSmall ? "100%" : "690px")};
  height: fit-content;
`;

const ProfileWrapper = styled.div.attrs((props) => {})`
  position: relative;
  width: ${(props) => (props.$isSmall ? "100px" : "150px")};
  height: ${(props) => (props.$isSmall ? "100px" : "150px")};
`;

const ProfileLabel = styled.label.attrs((props) => {})`
  position: absolute;
  bottom: 0;
  right: 0;
  height: ${(props) => (props.$isSmall ? "27px" : "41px")};
  width: ${(props) => (props.$isSmall ? "27px" : "41px")};
  cursor: pointer;
`;

const ProfileEditIcon = styled.img.attrs((props) => {})`
  width: 100%;
  height: 100%;
`;

const ProfileEditInput = styled.input.attrs((props) => {})`
  display: none;
`;

const InputContainer = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const EditBtnWrapper = styled.div.attrs((props) => {})`
  display: flex;
  justify-content: center;
  align-items: center;
  height: fit-content;
  width: 100%;
  margin: ${(props) =>
    props.$isSmall ? "28px 0px 20px 0px" : "50px 0px 40px 0px"};
`;

const WithdrawalBtn = styled.button.attrs((props) => {})`
  display: flex;
  justify-content: center;
  align-items: center;
  height: fit-content;
  width: fit-content;
  padding: 10px;
  border-bottom: 1px solid #898e99;
  cursor: pointer;
`;
